/**
 * healthService.js
 * Separate connectivity checks for cloud and local backends.
 * No UI changes; log results in dev mode.
 */
import axios from 'axios';

/** Check cloud (deployed) backend health */
export async function checkCloudConnectivity() {
  try {
    const resp = await axios.get(
      'https://alekhineai-app-267375680463.us-central1.run.app/connectivity-test',
      { withCredentials: false }
    );
    if (process.env.NODE_ENV !== 'production') console.log('cloud', resp.data);
    return { ok: true, data: resp.data };
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.error('cloud', error);
    return { ok: false, error };
  }
}

/** Check local (dev) backend health */
export async function checkLocalConnectivity() {
  try {
    const resp = await axios.get(
      'http://localhost:5000/connectivity-test',
      { withCredentials: false }
    );
    if (process.env.NODE_ENV !== 'production') console.log('local', resp.data);
    return { ok: true, data: resp.data };
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.error('local', error);
    return { ok: false, error };
  }
}

/** Optional: run both checks in parallel */
export async function checkConnectivity() {
  const [cloud, local] = await Promise.all([
    checkCloudConnectivity(),
    process.env.NODE_ENV !== 'production' ? checkLocalConnectivity() : null
  ]);
  return { cloud, local };
}
